import React from "react";
import { Link } from "react-router-dom";

import Logo from "../../../images/output-onlinepngtools-removebg-preview.png";
import img1 from "../../../images/download_mastercard2-removebg-preview.png";
import img2 from "../../../images/download_netbanking-removebg-preview.png";
import img3 from "../../../images/download_paytm-removebg-preview.png";
import img4 from "../../../images/PhonePe-Logo.wine-removebg-preview.png";
import img5 from "../../../images/download_rupay-removebg-preview.png";
import img6 from "../../../images/download_visa-removebg-preview.png";
import img7 from "../../../images/google-pay-logo-400W-200x200-removebg-preview.png";
import img8 from "../../../images/Cash-on-Delivery033_large-1-removebg-preview.png";
import img9 from "../../../images/360-3606562_bhim-logo-bhim-upi-removebg-preview.png";

import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import AutorenewOutlinedIcon from "@mui/icons-material/AutorenewOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LaunchIcon from "@mui/icons-material/Launch";

import "./footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();
  const paymentImages = [
    { src: img6, name: "Visa" },
    { src: img1, name: "Mastercard" },
    { src: img5, name: "RuPay" },
    { src: img9, name: "BHIM UPI" },
    { src: img7, name: "Google Pay" },
    { src: img4, name: "PhonePe" },
    { src: img3, name: "Paytm" },
    { src: img2, name: "Net Banking" },
    { src: img8, name: "Cash on Delivery" },
  ];

  const vendorUrl = process.env.REACT_APP_VENDOR_URL || "https://vendor.imonline.shop";

  return (
    <footer className="site-footer" role="contentinfo" aria-label="IM Online Shopping Footer">
      {/* ─── 1. Top Trust & Pillars Strip ─── */}
      <section className="footer-trust-strip" aria-label="Key Marketplace Benefits">
        <div className="footer-trust-container">
          <div className="footer-trust-item">
            <div className="footer-trust-icon">
              <StorefrontOutlinedIcon />
            </div>
            <div className="footer-trust-content">
              <h4 className="footer-trust-title">Verified Local Shops</h4>
              <p className="footer-trust-desc">Shop directly from trusted local retailers & boutiques</p>
            </div>
          </div>

          <div className="footer-trust-item">
            <div className="footer-trust-icon">
              <LocalShippingOutlinedIcon />
            </div>
            <div className="footer-trust-content">
              <h4 className="footer-trust-title">Flexible Delivery</h4>
              <p className="footer-trust-desc">Fast home delivery or convenient store pickup</p>
            </div>
          </div>

          <div className="footer-trust-item">
            <div className="footer-trust-icon">
              <SecurityOutlinedIcon />
            </div>
            <div className="footer-trust-content">
              <h4 className="footer-trust-title">100% Secure Payments</h4>
              <p className="footer-trust-desc">Encrypted gateway, UPI, Cards & Cash on Delivery</p>
            </div>
          </div>

          <div className="footer-trust-item">
            <div className="footer-trust-icon">
              <AutorenewOutlinedIcon />
            </div>
            <div className="footer-trust-content">
              <h4 className="footer-trust-title">7-Day Easy Returns</h4>
              <p className="footer-trust-desc">Doorstep pickup & direct instant bank refunds</p>
            </div>
          </div>
        </div>
      </section>

      {/* ─── 2. Main Navigation Grid ─── */}
      <div className="footer-main-container">
        {/* Brand & Mission Column */}
        <div className="footer-brand-col">
          <Link to="/" className="footer-brand-logo-link" aria-label="IM Online Home">
            <img src={Logo} alt="IM Online Shopping" className="footer-brand-logo-img" />
          </Link>

          <p className="footer-brand-tagline">
            India's local multi-vendor marketplace connecting customers with nearby retail
            stores, fashion boutiques, footwear, electronics, and daily essentials.
          </p>

          <div className="footer-contact-pills">
            <span className="footer-contact-item">
              <LocationOnOutlinedIcon />
              <span>Ahmedgarh, Punjab 148021, India</span>
            </span>
            <a href="tel:+917696145465" className="footer-contact-item">
              <PhoneOutlinedIcon />
              <span>+91 76961 45465</span>
            </a>
            <a href="mailto:support@imonline.shop" className="footer-contact-item">
              <EmailOutlinedIcon />
              <span>support@imonline.shop</span>
            </a>
          </div>

          <div className="footer-social-wrap">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="footer-social-btn"
            >
              <FacebookIcon />
            </a>
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="footer-social-btn"
            >
              <InstagramIcon />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Twitter"
              className="footer-social-btn"
            >
              <TwitterIcon />
            </a>
            <a
              href="https://wa.me/917696145465"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
              className="footer-social-btn"
            >
              <WhatsAppIcon />
            </a>
          </div>
        </div>

        {/* Column 1: Customer Care */}
        <div className="footer-link-col">
          <h4 className="footer-col-heading">Customer Care</h4>
          <Link to="/orders/Details/me" className="footer-nav-link">
            Track My Orders
          </Link>
          <Link to="/user/All/return/orders" className="footer-nav-link">
            Returns & Exchanges
          </Link>
          <Link to="/profile/Cancel-Orders-Detail" className="footer-nav-link">
            Cancelled Orders & Refunds
          </Link>
          <Link to="/user-profile/add-bank-account/" className="footer-nav-link">
            Refund Bank Account
          </Link>
          <Link to="/user/complain/request" className="footer-nav-link">
            Help & Customer Support
          </Link>
          <Link to="/how-to-shop" className="footer-nav-link">
            Shopping Guide & FAQ
          </Link>
        </div>

        {/* Column 2: Explore & Shop */}
        <div className="footer-link-col">
          <h4 className="footer-col-heading">Explore Market</h4>
          <Link to="/marketplace/search?type=shops" className="footer-nav-link">
            Explore Nearby Shops
          </Link>
          <Link to="/Product" className="footer-nav-link">
            Catalogue & Products
          </Link>
          <Link to="/marketplace/search" className="footer-nav-link">
            Search Marketplace
          </Link>
          <Link to="/user/wishlist" className="footer-nav-link">
            My Saved Wishlist
          </Link>
          <Link to="/promotions" className="footer-nav-link">
            Promotions & Offers
          </Link>
          <Link to="/about/GiftBox" className="footer-nav-link">
            Gift Box Packaging
          </Link>
        </div>

        {/* Column 3: Our Policies */}
        <div className="footer-link-col">
          <h4 className="footer-col-heading">Our Policies</h4>
          <Link to="/about/return-and-exchange" className="footer-nav-link">
            7-Day Return Policy
          </Link>
          <Link to="/about/Shipping-Tracking" className="footer-nav-link">
            Shipping & Fulfillment
          </Link>
          <Link to="/Cookies-Policy" className="footer-nav-link">
            Privacy & Cookie Policy
          </Link>
          <Link to="/terms-and-conditions" className="footer-nav-link">
            Terms of Service
          </Link>
          <Link to="/about/Payment" className="footer-nav-link">
            Payment Methods
          </Link>
          <Link to="/about/Security" className="footer-nav-link">
            Security & Safe Shopping
          </Link>
        </div>

        {/* Column 4: Sellers & About */}
        <div className="footer-link-col">
          <h4 className="footer-col-heading">Sellers & About</h4>
          <a
            href={`${vendorUrl}/vendor`}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-nav-link footer-highlight-link"
            title="Register as a Local Merchant on IM Online"
          >
            <StorefrontOutlinedIcon style={{ fontSize: "16px" }} />
            <span>Sell on IM Online</span>
            <span className="footer-link-badge">0% Comm</span>
          </a>
          <a
            href={`${vendorUrl}/vendor/requirements`}
            target="_blank"
            rel="noopener noreferrer"
            className="footer-nav-link"
          >
            <span>Seller Guidelines</span>
            <LaunchIcon style={{ fontSize: "13px" }} />
          </a>
          <Link to="/about/BrandedProfile" className="footer-nav-link">
            About Us & Brand Story
          </Link>
          <Link to="/about/Product-And-Pricing" className="footer-nav-link">
            Size & Pricing Guide
          </Link>
          <Link to="/userprofile" className="footer-nav-link">
            My Account Dashboard
          </Link>
        </div>
      </div>

      {/* ─── 3. Payment Methods & Security Strip ─── */}
      <section className="footer-payment-section" aria-label="Payment Methods and Security">
        <div className="footer-payment-inner">
          <div className="footer-payment-left">
            <span className="footer-payment-label">Accepted Payments:</span>
            <div className="footer-payment-badges">
              {paymentImages.map((item, index) => (
                <span key={index} className="footer-pay-badge" title={item.name}>
                  <img src={item.src} alt={item.name} />
                </span>
              ))}
            </div>
          </div>

          <div className="footer-security-pill">
            <LockOutlinedIcon />
            <span>256-bit SSL Encrypted & 100% Purchase Protection</span>
          </div>
        </div>
      </section>

      {/* ─── 4. Copyright & Legal Sub-Bar ─── */}
      <div className="footer-bottom-bar">
        <div className="footer-bottom-inner">
          <p className="footer-copyright-text">
            © {currentYear} IMSHOP — IM Online Shopping Marketplace. All Rights Reserved. Built for Indian Local Retailers.
          </p>

          <div className="footer-legal-links">
            <Link to="/Cookies-Policy" className="footer-legal-link">
              Privacy
            </Link>
            <span style={{ color: "#334155" }}>•</span>
            <Link to="/terms-and-conditions" className="footer-legal-link">
              Terms
            </Link>
            <span style={{ color: "#334155" }}>•</span>
            <Link to="/about/return-and-exchange" className="footer-legal-link">
              Returns
            </Link>
            <span style={{ color: "#334155" }}>•</span>
            <Link to="/about/Security" className="footer-legal-link">
              Security
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
